import { PaymentShareMemberApi } from 'api-typings/users/users';
import { PaymentShareMemberSpentAmount } from './payment-share-members-spent-amount.model';

export function transformPaymentShareMemberSpentAmount(
  paymentShareMember: PaymentShareMemberApi,
): PaymentShareMemberSpentAmount {
  if (paymentShareMember.current_spent_amount === undefined) {
    throw new ReferenceError('Missing current_spent_amount field.');
  }
  return {
    id: paymentShareMember.id,
    entityId: paymentShareMember.entity_id,
    entityType: paymentShareMember.entity_type,
    currentSpentAmount: paymentShareMember.current_spent_amount,
  };
}
